// 我收到的
import React, { useContext, useState, useEffect, useCallback } from "react";
import api from "../../api";
import contextMenus, { Names } from "../../contextMenus";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { MenuEnum, ShareType } from "../../components/List/SharesFilters/config";
import events from "../../context/events";
import TableList from "../../components/TableList";
import { ColumnsItem, JustifyContent } from "../../components/TableList/BaseComponents/Header";
import {
  getFilePath,
  getFullPathByForomId,
  getIconUrl,
  notUseJoySpaceOffline,
  openLink,
  time
} from "../../util";
import { changeEgovUrl } from "@/utils/tools";
import ContextMenu from "../../components/List/ContextMenu";
import { Icons } from "../../Icon";
import SharesFilters from "../../components/List/SharesFilters";
import Tags, { TagType } from "../../components/Tags";
import openDeleteModal from "../../contextModal/DeleteModal";
import { pageSize } from "../../config/basics.config";
import { useHistory } from "react-router-dom";
import { Tooltip } from "antd";
import { ActionFnEnum, ActionType, ContextMenuMode, FileType, MenusType } from "../../types";
import { isFocusEnv } from "@/utils";
import { Tabs } from "../MySpace/config";
import UpdataService from "../../reloadUtils";
import context from "../../context";
import { addJoysapceMap } from "../../api/permissions";
import { joyspacePermissionType } from "../../config/permissions.config";
import { useNavigator } from "@/utils/NetworkCheck";
import SyncStatusTag from "../../components/SyncStatusTag";
import { useListData } from "../../components/TableList/Use/useListData";

interface IProps {
  defaultFilter: any;
  activeKey: Tabs;
  path?: MenusType;
  pagination?: boolean;
}
const key = MenusType.SHAREBY;
// 获取数据
const getList = (params: any) => {
  return new Promise((resolve, reject) => {
    api.pages
      .shares(params)
      .then((res) => {
        if (res) {
          res.pages = (res.shares || [])?.map(
            (item: { page: any; location: any; share: any; shareMethod: any }) => {
              const lastPathArr = item.location.fullName.split("$@$");
              if (item.page.kl_type) {
                item.page.fullName = "知识库：" + item.page.space_name;
              } else {
                item.page.fullName = item.location.fullName.replace(/\$@\$/g, "/");
              }
              item.page.fullPath = item.location.fullPath.replace(/\$@\$/g, "/");
              item.page.lastPath = lastPathArr[lastPathArr.length - 1] || "/";
              item.page.shareName = item.share?.name || "";
              item.page.time = time.format((item as any).shared_at);
              item.page.shareTitle = item.page.share_method_Name || "";
              item.page.share = item.share;
              item.page.path = getFilePath(
                item.page.spaceType,
                getFullPathByForomId(item.page?.full_path)
              );
              return item.page;
            }
          );
        }
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
function ListShares(props: IProps) {
  const { defaultFilter = MenuEnum.SHARES, activeKey, path, pagination = false } = props;
  const globalContext = useContext<GlobalContextConfig>(GlobalContext);
  const { addFolderInfo } = useContext(context);
  const history = useHistory();
  const {
    list,
    setList,
    total,
    setTotal,
    loading,
    isLoadMore,
    setLoadMore,
    onButtom,
    setPageIndex
  } = useListData({
    requestPagesFunc: getList,
    isEmitLoadMore: true,
    isFilter: false,
    isCategory: false,
    key
  });
  const [columns, setColumns] = useState<ColumnsItem[]>([
    { title: "标题", key: "title", dataIndex: "title", ellipsis: true },
    {
      title: "",
      key: "filters",
      dataIndex: defaultFilter === MenuEnum.SHARES ? "shareName" : "fullName",
      filters: true,
      render: (columnsItem: ColumnsItem) => (
        <SharesFilters
          disabled={!globalContext.onLine && !notUseJoySpaceOffline()}
          defaultActiveKey={defaultFilter === MenuEnum.SHARES ? MenuEnum.SHARES : MenuEnum.PATH}
          onChange={(item: any) => {
            // if 较多时可以尝试使用策略模式
            let res = { ...columnsItem };
            if (item === MenuEnum.PATH) {
              res.dataIndex = "fullName";
            } else if (item === MenuEnum.SHARES) {
              res.dataIndex = "shareName";
            } else if (item === MenuEnum.SHARES_TYPE) {
              res.dataIndex = "shareTitle";
            }
            const index = columns.findIndex((item: ColumnsItem) => {
              return item.key === res.key;
            });
            const _columns = [...columns];
            _columns.splice(index, 1);
            _columns.splice(index, 0, res);
            setColumns(_columns);
          }}
        />
      ),
      width: "20%",
      ellipsis: true
    },
    {
      title: "分享时间",
      key: "time",
      dataIndex: "time",
      width: "25%",
      style: {
        minWidth: "142px"
      },
      justifyContent: JustifyContent.Left
    },
    {
      title: "",
      key: "actions",
      dataIndex: "actions",
      actions: true,
      width: "5%",
      style: {
        minWidth: "30px"
      },
      justifyContent: JustifyContent.Center
    }
  ]);

  useEffect(() => {
    events.on("joyspace:onButtom", onButtom);
    return () => {
      events.off("joyspace:onButtom", onButtom);
    };
  }, [onButtom]);

  const openPage = async (columnsItem: ColumnsItem, item: any) => {
    if (columnsItem.key === "filters" && columnsItem.dataIndex === "fullName") {
      if (item.fullName === "/" || item.kl_type) {
        return;
      }
      // const res: any = await addJoysapceMap(item.space_category_id, item, addFolderInfo);
      const path = item.path;
      // const path = res !== joyspacePermissionType.ReadDel
      //   ? getFilePath(res.type, item.space_category_id)
      //   : item.path;
      history.push(path);
      return;
    }
    if (!item.status && useNavigator.onLine) {
      openDeleteModal(FileType.Page, item.id);
      return;
    }
    if (columnsItem.key === "title") {
      openLink(item, globalContext.appRuntimeEnv.joyspaceHost);
    }
  };
  const getTips = (item: any, props: any) => {
    if (item.key === "filters" && item.dataIndex === "fullName") {
      if ((props as any)[item.dataIndex] === "/") {
        return "文件所属文件夹未分享，暂不可获取文件位置";
      }
    }
    return item.ellipsis ? (props as any)[item.dataIndex] : "";
  };
  const className = useCallback((columnsItem: ColumnsItem, value = "/") => {
    if (columnsItem.key === "title") {
      return "joyspace-list-title joyspace-list-ellipsis";
    } else if (columnsItem.ellipsis || columnsItem.key === "filters") {
      const names = "joyspace-list-text joyspace-list-ellipsis";
      if (columnsItem.dataIndex === "fullName" && (value === "/" || value.includes("知识库"))) {
        return `${names} joyspace-list-path-disabled`;
      }
      return columnsItem.dataIndex === "fullName" ? `joyspace-list-path ${names}` : names;
    } else {
      return "joyspace-list-text";
    }
  }, []);
  return (
    <div
      className={isFocusEnv() ? "joyspace-list-table joyspace-list-share" : "joyspace-list-table"}
    >
      <TableList
        disabledHeader={false}
        isLoadMore={isLoadMore}
        columns={columns}
        list={list}
        loading={loading}
        from={Names.SHARES}
        pagination={pagination}
        folderFrom={{
          draggerUploadShow: activeKey !== Tabs.SHARES
        }}
        renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
          if (item.isDisabled) {
            return (
              <span className="joyspace-trigger-icon" style={{ color: "#cccccc" }}>
                {Icons.trigger}
              </span>
            );
          }
          return (
            <ContextMenu
              render={contextMenus.page(
                Names.SHARES,
                globalContext,
                undefined,
                "",
                path === MenusType.TEAMSPACE ? Names.TEAM_SPACE : Names.SHARES
              )}
              callbackProps={{
                contextMenuMode,
                originId: path === MenusType.TEAMSPACE ? "teamRoot" : "",
                data: item,
                setData: (data: any) => {
                  events.emit("list.partial.refresh", {
                    changeData: data,
                    key
                  });
                },
                remove: () => {
                  console.log("remove");
                },
                reload: () => {
                  console.log("reload");
                }
              }}
            />
          );
        }}
        preOptions={(item: any, data: any, isExist: any) => {
          return (
            item.dataIndex === "title" && (
              <img
                src={
                  !isExist ? changeEgovUrl(data.icon_url) : getIconUrl(data.type || data.page_type)
                }
                data-icon
              />
            )
          );
        }}
        afterOptions={(item: any, data: any) => {
          return (
            item.dataIndex === "title" &&
            data.isCollected && <Tags left={5} TagType={TagType.Follow} />
          );
        }}
        contentRender={(columnsItem: ColumnsItem, item: any) => {
          if (columnsItem.dataIndex === "time" && item.isNew) {
            return <SyncStatusTag status={item.syncStatus} />;
          }
          return (
            <Tooltip placement="top" title={getTips(columnsItem, item)}>
              <span
                className={className(columnsItem, (item as any)[columnsItem.dataIndex])}
                onClick={() => {
                  openPage?.(columnsItem, item);
                }}
              >
                {(item as any)[columnsItem.dataIndex]}
              </span>
            </Tooltip>
          );
        }}
        onButtom={onButtom}
        handleItem={openPage}
      />
    </div>
  );
}

export default ListShares;
